import { socialCardKeys } from 'src/constants/socialcard.constant';

const SocialVideoFallback = ({ cardItem, cardWidth, darkModeEnabled = false }) => {
  const isTiktok = cardItem && cardItem[socialCardKeys.sourcePlatform] === 'tiktok';

  return (
    <div
      className={darkModeEnabled ? "border-none relative z-0 transition-all w-full card-holder" : "border border-gray-200 relative z-0 transition-all w-full card-holder"}
      style={{
        maxWidth: isTiktok ? "21rem" : "39rem",
        height: isTiktok ? "580px" : "220px",
        cursor: "default",
        minWidth: cardWidth,
        borderRadius: "10px",
        backgroundColor: "#000",
      }}
    />
  );
};

export default SocialVideoFallback;
